import { inject } from 'vue';

export const agentSetupContextKey = 'agentSetupContext';

export function useAgentSetupContext() {
  const context = inject(agentSetupContextKey, null);
  if (context === null) {
    throw new Error('Agent setup context was not provided.');
  }
  return context;
}
